import { Lock } from 'lucide-react';

import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';
import { cn } from '@apps/web/lib/utils';

export function InternalReadonlyBadge({
    className,
}: {
    readonly className?: string;
}) {
    return (
        <Tooltip delayDuration={300}>
            <TooltipTrigger asChild={true}>
                <span
                    className={cn(
                        'border-border bg-muted/70 text-muted-foreground inline-flex shrink-0 items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium',
                        className,
                    )}
                    title="Internal read-only"
                >
                    <Lock className="h-3 w-3 shrink-0" />
                    <span data-internal-readonly-badge-label="true">
                        Internal read-only
                    </span>
                </span>
            </TooltipTrigger>
            <TooltipContent>
                <p className="max-w-xs">
                    This session runs the v3 agent against real agency data with
                    read-only tools.
                </p>
            </TooltipContent>
        </Tooltip>
    );
}
